import { TargetScoreRangeTemplate } from '../..';

export function findFirmDefaultTemplate(templates: TargetScoreRangeTemplate[]) {
  return templates.find((template) => template.firmDefaults);
}
